export const buildShoppingCartUrl = ({
    companyCartPath,
    companyShopUrl,
}: Partial<{
    companyCartPath: string;
    companyShopUrl: string;
}>) => (companyShopUrl ? `${companyShopUrl}${companyCartPath ?? '/cart'}` : '');
